import { useMediaQuery } from "@mui/material";

// Punto de quiebre único compartido por todo el módulo: por debajo de este
// ancho se prioriza la vista de tarjetas y los controles se compactan.
const useEsMobile = () => useMediaQuery("(max-width:900px)");

export default useEsMobile;
